/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_Tab_FieldInputs */

const vi_grower_area_qr_tab_field = /** @type {(inputs: Grower_Area_Qr_Tab_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã cắm vùng`)
};

/**

* @param {Grower_Area_Qr_Tab_FieldInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_tab_field = /** @type {((inputs?: Grower_Area_Qr_Tab_FieldInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_Tab_FieldInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_tab_field(inputs)
});